import auth from "../providers/Auth.Provider";

const staff = auth.authProvider.GetAuthenticatedStaff();
const option = { icon: "https://www.igeniecare.co.uk/assets/img/logo.png", vibrate: 1, badge: "https://www.igeniecare.co.uk/assets/img/logo.png" };

const REQUEST_ACCESS = () => {
    if (!("Notification" in window)) {
        alert("This browser does not support desktop notification");
    } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(function (permission) {
            // If the user accepts, let's create a notification
            console.log(permission);
        });
    }
};

export const SystemNotification = (message) => {
    new Notification(`${staff && staff.site.name} : Broadcast Message`, { ...option, data: message, body: message });
};

export default REQUEST_ACCESS;
